import { HttpErrorResponse } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';

import { createSelector, StoreConfig } from '@ngrx/store';

import { ConfigsMap, FeatureCode } from '@recruitee/http/types';
import { createSingleEntityStore, memoizeSelector, SingleEntityState } from '@recruitee/ngrx';

import { FEATURE_SPEC, FeatureSpecEntity } from './feature-spec.types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<FeatureSpecEntity>()(
  'FeatureSpec',
  {
    customActions: adapter => ({
      fetchFailed: (state, payload: { error: HttpErrorResponse | Error }) =>
        adapter.setError(state, payload.error.message),
    }),
  },
);

const FeatureSpecSelectors = {
  ...selectors,
  forCode: memoizeSelector(<T extends FeatureCode>(code: T) =>
    createSelector(selectors.data, data => {
      const entity = data?.find(feature => feature.codename === code);
      if (!entity) {
        return undefined;
      }
      return <typeof entity & { configuration: ConfigsMap[typeof code] }>entity;
    }),
  ),
};

export const FeatureSpecStoreToken = new InjectionToken('FeatureSpecStoreToken', {
  providedIn: 'root',
  factory: (): StoreConfig<SingleEntityState<FeatureSpecEntity>> => ({
    initialState: {
      loaded: true,
      failed: false,
      pending: false,
      error: false,
      data: inject(FEATURE_SPEC),
    },
  }),
});

export {
  FeatureSpecSelectors,
  actions as FeatureSpecActions,
  reducer as FeatureSpecReducer,
  namespace as FeatureSpecNamespace,
};
